/* Nakshatra Store — theme interactivity (no framework, replaces React state) */
(function () {
  "use strict";

  /* ---------- countdown timers (data-countdown="hours") ---------- */
  function pad(n) { return String(n).padStart(2, "0"); }
  document.querySelectorAll("[data-countdown]").forEach(function (el) {
    var hours = parseInt(el.getAttribute("data-countdown"), 10) || 24;
    var end = Date.now() + hours * 3600 * 1000;
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = el.querySelector("[data-h]"), mEl = el.querySelector("[data-m]"), sEl = el.querySelector("[data-s]");
      if (hEl) { hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s); }
      else { el.textContent = pad(h) + ":" + pad(m) + ":" + pad(s); }
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- rotating text (promo strip) ---------- */
  document.querySelectorAll("[data-rotator]").forEach(function (el) {
    var items = JSON.parse(el.getAttribute("data-rotator") || "[]");
    if (!items.length) return;
    var i = 0, target = el.querySelector("[data-rotator-text]") || el;
    var ms = parseInt(el.getAttribute("data-rotator-ms"), 10) || 4000;
    setInterval(function () {
      i = (i + 1) % items.length;
      target.classList.remove("animate-fade-in"); void target.offsetWidth;
      target.textContent = items[i];
      target.classList.add("animate-fade-in");
    }, ms);
  });

  /* ---------- hero carousel ---------- */
  document.querySelectorAll("[data-carousel]").forEach(function (root) {
    var slides = root.querySelectorAll("[data-slide]");
    var dots = root.querySelectorAll("[data-dot]");
    if (slides.length < 2) return;
    var idx = 0, ms = parseInt(root.getAttribute("data-carousel-ms"), 10) || 6000, timer;
    function show(n) {
      idx = n;
      slides.forEach(function (s, i) { s.hidden = i !== n; if (i === n) { s.classList.remove("animate-fade-in"); void s.offsetWidth; s.classList.add("animate-fade-in"); } });
      dots.forEach(function (d, i) { d.setAttribute("data-active", i === n ? "true" : "false"); });
    }
    function next() { show((idx + 1) % slides.length); }
    function start() { timer = setInterval(next, ms); }
    dots.forEach(function (d, i) { d.addEventListener("click", function () { clearInterval(timer); show(i); start(); }); });
    show(0); start();
  });

  /* ---------- tab groups (category rail, etc.) ---------- */
  document.querySelectorAll("[data-tabs]").forEach(function (root) {
    var btns = root.querySelectorAll("[data-tab]");
    var panels = root.querySelectorAll("[data-panel]");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-tab");
        btns.forEach(function (b) { b.setAttribute("data-active", b === btn ? "true" : "false"); });
        panels.forEach(function (p) { p.hidden = p.getAttribute("data-panel") !== key; });
      });
    });
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (root) {
    var main = root.querySelector("[data-gallery-main]");
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        main.src = t.getAttribute("data-src");
        main.alt = t.getAttribute("data-alt") || main.alt;
        thumbs.forEach(function (x) { x.setAttribute("data-active", x === t ? "true" : "false"); });
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll("[data-qty]").forEach(function (box) {
    var input = box.querySelector("input");
    box.querySelector("[data-qty-dec]").addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    box.querySelector("[data-qty-inc]").addEventListener("click", function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  /* ---------- live "add to cart" price (product page) ---------- */
  document.querySelectorAll("[data-atc-form]").forEach(function (form) {
    var qtyInput = form.querySelector('input[name="quantity"]');
    var priceEl = form.querySelector("[data-atc-price]");
    var unit = parseInt(form.getAttribute("data-unit-price"), 10) || 0;
    function update() {
      if (!priceEl) return;
      var q = parseInt(qtyInput.value, 10) || 1;
      priceEl.textContent = formatMoney(unit * q);
    }
    if (qtyInput) qtyInput.addEventListener("change", update);
  });

  function formatMoney(cents) {
    var v = (cents / 100);
    return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  }

  /* ---------- AJAX add to cart + drawer count ---------- */
  document.querySelectorAll("[data-atc-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      var btn = form.querySelector('[type="submit"]');
      // If "buy now" was clicked, let it POST normally to /cart.
      if (form.dataset.buynow === "1") return;
      e.preventDefault();
      var data = new FormData(form);
      if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.innerHTML = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: data, headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll("[data-cart-count]").forEach(function (c) { c.textContent = cart.item_count; c.hidden = false; });
          if (btn) { btn.innerHTML = "✓ Added to cart"; setTimeout(function () { btn.innerHTML = btn.dataset.label; btn.disabled = false; }, 1400); }
        })
        .catch(function () { if (btn) { btn.innerHTML = btn.dataset.label; btn.disabled = false; } window.location.href = "/cart"; });
    });
    // mark buy-now clicks
    var buyNow = form.querySelector("[data-buynow]");
    if (buyNow) buyNow.addEventListener("click", function () { form.dataset.buynow = "1"; });
    var addBtn = form.querySelector("[data-add]");
    if (addBtn) addBtn.addEventListener("click", function () { form.dataset.buynow = "0"; });
  });

  /* ---------- exit-intent modal (product page) ---------- */
  var exitModal = document.querySelector("[data-exit-modal]");
  if (exitModal) {
    var dismissed = false;
    function openExit() { if (!dismissed) exitModal.hidden = false; }
    function closeExit() { dismissed = true; exitModal.hidden = true; }
    document.addEventListener("mouseleave", function (e) { if (e.clientY <= 0) openExit(); });
    var fallback = setTimeout(openExit, 45000);
    exitModal.querySelectorAll("[data-exit-close]").forEach(function (b) { b.addEventListener("click", function () { clearTimeout(fallback); closeExit(); }); });
    exitModal.addEventListener("click", function (e) { if (e.target === exitModal) { clearTimeout(fallback); closeExit(); } });
  }

  /* ---------- header: mobile drawer ---------- */
  (function () {
    var drawer = document.querySelector("[data-mobile-nav]");
    var overlay = document.querySelector("[data-drawer-overlay]");
    var openers = document.querySelectorAll("[data-menu-toggle]");
    var closers = document.querySelectorAll("[data-menu-close]");
    if (!drawer || !overlay) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      drawer.hidden = false;
      // next frame so the transform transition runs
      requestAnimationFrame(function () { drawer.setAttribute("data-open", "true"); });
      document.body.setAttribute("data-drawer-open", "true");
      openers.forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      var first = drawer.querySelector("[data-menu-close]");
      if (first) first.focus();
    }
    function close() {
      drawer.removeAttribute("data-open");
      overlay.hidden = true;
      document.body.removeAttribute("data-drawer-open");
      openers.forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      setTimeout(function () { drawer.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener("click", open); });
    closers.forEach(function (b) { b.addEventListener("click", close); });
    overlay.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !drawer.hidden) close();
    });
    // trap focus inside the drawer
    drawer.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // close when a link is followed
    drawer.querySelectorAll("a[href]").forEach(function (a) {
      a.addEventListener("click", function () { close(); });
    });
  })();

  /* ---------- header: desktop dropdowns / mega menu ---------- */
  (function () {
    var items = document.querySelectorAll("[data-dropdown]");
    if (!items.length) return;
    var closeTimer;

    function setOpen(item, on) {
      var btn = item.querySelector("[data-dropdown-btn]");
      var panel = item.querySelector("[data-dropdown-panel]");
      if (!btn || !panel) return;
      panel.hidden = !on;
      item.setAttribute("data-open", on ? "true" : "false");
      btn.setAttribute("aria-expanded", on ? "true" : "false");
    }
    function closeAll() { items.forEach(function (i) { setOpen(i, false); }); }

    items.forEach(function (item) {
      var btn = item.querySelector("[data-dropdown-btn]");
      item.addEventListener("mouseenter", function () { clearTimeout(closeTimer); closeAll(); setOpen(item, true); });
      item.addEventListener("mouseleave", function () { closeTimer = setTimeout(function () { setOpen(item, false); }, 140); });
      if (btn) btn.addEventListener("click", function (e) {
        e.preventDefault();
        var isOpen = item.getAttribute("data-open") === "true";
        closeAll();
        setOpen(item, !isOpen);
      });
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
    document.addEventListener("click", function (e) {
      if (!e.target.closest("[data-dropdown]")) closeAll();
    });
  })();

  /* ---------- header: search panel ---------- */
  (function () {
    var panel = document.querySelector("[data-search-panel]");
    var toggles = document.querySelectorAll("[data-search-toggle]");
    var closers = document.querySelectorAll("[data-search-close]");
    if (!panel || !toggles.length) return;
    var input = panel.querySelector("[data-search-input]");

    function set(on) {
      panel.hidden = !on;
      toggles.forEach(function (t) { t.setAttribute("aria-expanded", on ? "true" : "false"); });
      if (on && input) input.focus();
    }
    toggles.forEach(function (t) { t.addEventListener("click", function () { set(panel.hidden); }); });
    closers.forEach(function (c) { c.addEventListener("click", function () { set(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) set(false); });
  })();

  /* ---------- pincode check (cosmetic, mirrors source) ---------- */
  document.querySelectorAll("[data-pincode]").forEach(function (wrap) {
    var btn = wrap.querySelector("button");
    var input = wrap.querySelector("input");
    var out = wrap.querySelector("[data-pincode-result]");
    if (btn) btn.addEventListener("click", function () {
      var v = (input.value || "").trim();
      if (out) out.textContent = /^\d{6}$/.test(v) ? "✓ Delivers to " + v + " · COD available" : "Enter a valid 6-digit pincode";
    });
  });
})();
